import { render, staticRenderFns } from "./SamplesFilter.vue?vue&type=template&id=3d72e4c2&scoped=true"
import script from "./SamplesFilter.vue?vue&type=script&lang=js"
export * from "./SamplesFilter.vue?vue&type=script&lang=js"
import style0 from "./SamplesFilter.vue?vue&type=style&index=0&id=3d72e4c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d72e4c2",
  null
  
)

export default component.exports